import SubmitMenuContainer from './SubmitMenu.container';
import SubmitMenu from './SubmitMenu';
export default SubmitMenuContainer(SubmitMenu);

//# sourceMappingURL=index.js.map